import React from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import { ConductorTransportMode } from '../../../../types/generated-types';

export { ConductorTransportMode };

export const canRepublishConductorMetadata = (
  sourceType?: string | null,
  lastDiscoveryStatus?: string | null,
) => sourceType === 'Conductor' && lastDiscoveryStatus === 'mapped';

interface ConductorInitializationOptionsProps {
  transportMode: ConductorTransportMode;
  onTransportModeChange: (mode: ConductorTransportMode) => void;
  useInstalledCredentials: boolean;
  onUseInstalledCredentialsChange: (value: boolean) => void;
  credentialRef: string;
  onCredentialRefChange: (value: string) => void;
}

export function ConductorInitializationOptions({
  transportMode,
  onTransportModeChange,
  useInstalledCredentials,
  onUseInstalledCredentialsChange,
  credentialRef,
  onCredentialRefChange,
}: ConductorInitializationOptionsProps) {
  return (
    <>
      <FormControl component="fieldset" margin="normal">
        <FormLabel component="legend">Mitsubishi transport</FormLabel>
        <RadioGroup
          aria-label="Mitsubishi transport"
          value={transportMode}
          onChange={(_, value) =>
            onTransportModeChange(value as ConductorTransportMode)
          }
        >
          <FormControlLabel
            value={ConductorTransportMode.Auto}
            control={<Radio color="secondary" />}
            label="Auto (recommended): web direct first, BACnet fallback when available"
          />
          <FormControlLabel
            value={ConductorTransportMode.WebDirect}
            control={<Radio color="secondary" />}
            label="Web direct only"
          />
          <FormControlLabel
            value={ConductorTransportMode.Bacnet}
            control={<Radio color="secondary" />}
            label="Prefer BACnet when available, with web direct fallback"
          />
        </RadioGroup>
        <FormHelperText>
          Controller-native features such as schedules and setpoint limits still
          use web direct when required.
        </FormHelperText>
      </FormControl>

      <FormControl component="fieldset" margin="normal" fullWidth>
        <FormLabel component="legend">Web credentials</FormLabel>
        <FormControlLabel
          control={
            <Checkbox
              color="secondary"
              checked={useInstalledCredentials}
              onChange={(_, checked) =>
                onUseInstalledCredentialsChange(checked)
              }
            />
          }
          label="Use web credentials already installed on this Conductor"
        />
        {useInstalledCredentials ? (
          <FormHelperText>
            This includes the controller defaults when those are the credentials
            securely provisioned on the Conductor.
          </FormHelperText>
        ) : (
          <TextField
            label="Installed credential profile"
            value={credentialRef}
            onChange={(event) => onCredentialRefChange(event.target.value)}
            helperText="Enter the name of a credential profile that has already been securely installed on the Conductor. Passwords are not stored in Super."
            required
            fullWidth
            margin="dense"
          />
        )}
      </FormControl>
    </>
  );
}
